<div class="row" *ngIf="false">
    <div class="col-sm-6">
        <button class="epi-button" (click)="testGraph()">Test Graph</button>
        <button class="epi-button" (click)="getAvailableLoadsTeam()">Get "Available Loads Team"</button>
    </div>
</div>
<div class="row">
    <div class="col-sm-6">
        <customer-dropdown [parentForm]="orderPlannedForm" [ctrlName]="'billToCtrl'" [placeholder]="'Enter Code'"
                           [lookupType]="'billto'" (customerSelected)="onCustomerChange($event, 'billToCtrl')"></customer-dropdown>
    </div>
    <div class="col-sm-6">
        <kendo-datepicker name="testDate" [(ngModel)]="testDate"
                          [format]="'MM/dd/yyyy'" [ngModelOptions]="{standalone: true}">
        </kendo-datepicker>
        <kendo-timepicker name="testDate" [(ngModel)]="testDate"
                          [format]="'HH:mm'" [ngModelOptions]="{standalone: true}" [nowButton]="false">
        </kendo-timepicker>
        <button type="button" class="btn btn-primary" (click)="getCheckCallNote()">Get Text</button>
        <br />
        {{testText}}
    </div>
</div>
<div class="row">
    <div class="col-sm-2">
        <label class="fw-bold">City</label>
        <br />
        <!--<city-dropdown [parentForm]="testForm" [ctrlName]="'cityCtrl'" [placeholder]="'Select a City'"
        (citySelected)="cityChanged()" [cityId]="customer.cityId" [isRequired]="true"></city-dropdown>-->
        <city-state-zip-dropdown [parentForm]="testForm" [ctrlName]="'cityStateZipCtrl'" [placeholder]="'Select a City'"
                                 (citySelected)="citySTChanged($event)" [cityID]="cityID" [isRequired]="true"></city-state-zip-dropdown>
    </div>
    <div class="col-sm-2">
        {{city.cityStateZip}}
    </div>
</div>
<div class="row" *ngIf="false">
    <div class="col-sm-8">
        <button class="btn btn-secondary m-1" (click)="sendEmail()">Email</button>
        <button class="btn btn-secondary m-1" (click)="sendAvailableLoadOfferEmail(473257)">Email Offer</button>
    </div>
</div>
<div class="row">
    <div class="col-sm-12">
        <button class="btn btn-primary" (click)="testIsLoading()">Test Spinner</button>
    </div>
</div>
<div class="row">
    <div class="col">
        <city-form></city-form>
    </div>
</div>
<!--<kendo-datepicker name="testDate" [(ngModel)]="testDate"
                  [format]="'MM/dd/yyyy'" [ngModelOptions]="{standalone: true}">
</kendo-datepicker>
<kendo-timepicker name="testDate" [(ngModel)]="testDate"
                  [format]="'HH:mm'" [ngModelOptions]="{standalone: true}" [nowButton]="false">
</kendo-timepicker>
<button type="button" class="btn btn-primary" (click)="getCheckCallNote()">Get Text</button>
<br />
{{testText}}
-->
